<script>
import TermsOfService from './TermsOfService.vue'

export default {
    name: 'TermsOfServiceLink',
    components: {
        TermsOfService
    },
    props: {
        el: {
            type: String,
            default: 'div'
        },
        size: {
            type: String,
            default: 'sm'
        },
        text: {
            type: String,
            required: false
        }
    },
    computed: {},
    methods: {},
}
</script>

<template>
    <component :is="el">
        <a v-if="text" @click="$refs.tosModal.show()" href="javascript:{}">{{ text }}</a>
        <span v-else>En utilisant ce service, vous acceptez <a @click="$refs.tosModal.show()" href="javascript:{}">nos conditions d'utilisation &amp; politique de confidentialité</a></span>
        <!-- Modals -->
        <b-modal ref="tosModal" title="Conditions d'utilisation &amp; Politique de confidentialité" no-fade centered ok-only>
            <p class="my-2"><terms-of-service /></p>
        </b-modal>
    </component>
</template>